<kendo-dropdownlist [readonly]="!!options.readonly" [data]="options.values" [valuePrimitive]="true"
        [formControl]="control" textField="Text" valueField="Value" (valueChange)="onValueChange($event)">
</kendo-dropdownlist>